import { CatalogPage } from './components/CatalogPage';
import { Header } from './components/Header';
import { HomePage } from './components/HomePage';
import { ProductPage } from './components/ProductPage';
import { TagAssistantModal } from './components/TagAssistantModal';
import { DemoContext, DemoProvider } from './contexts/DemoContext';

export function Demo() {
  const pages = {
    home: <HomePage />,
    catalog: <CatalogPage />,
    product: <ProductPage />,
  };

  return (
    <DemoProvider>
      <div>
        <Header />

        <DemoContext.Consumer>
          {({ page }) => (
            <main>{pages[page as keyof typeof pages] ?? null}</main>
          )}
        </DemoContext.Consumer>

        <TagAssistantModal />
      </div>
    </DemoProvider>
  );
}
